module.exports = "data:image/png;base64,iVBORw0KGgoAAAANSUhEUgAAAC0AAAAsCAMAAADGmMENAAAAGXRFWHRTb2Z0d2FyZQBBZG9iZSBJbWFnZVJlYWR5ccllPAAAADBQTFRFy9nS2uni0ebc6+vr293c8/TzydHN6fLs4e7n/Pz85OTl09TU9vj30dHR////3u7pwPJ1xgAAAQlJREFUeNqc1FuWhCAMBNAEAgqSuP/dDko/sH2VU5+eS50oINlpytAyLinrIxrdGm5xXXjuwk0PMxT3L82Qfk3iHaaXjKhuIU+w5UIB1jwYlQiPIZlMwcE5qpAJOIpTDWQZ1KTZyNCPEqXujiXwNWNYtKFzpyeaWzfP8LlCtaOMa1KdEqyj1r150i32oFsSrN1qUU3ecM3LGYE16YPuerLLR4/3+DUIoOsNew8CaPpW3+taPSVYO52K9Zpvb1infSS6WCC21fU0Xty2Ya/jabkLWx2qvvi9/XRbEKmz7LM2uPFH14gepa6In33stNfThL1O06k+6LaSZROfpU03HemjJFHxqX/yJ8AA8wZnPEZ6XU8AAAAASUVORK5CYII="


//////////////////
// WEBPACK FOOTER
// ./src/components/SP/assets/AR.png
// module id = tzpp
// module chunks = 1